import * as Yup from 'yup'

export const schemaResetPassword = Yup.object({
  first: Yup.string().required(''),
  second: Yup.string().required(''),
  third: Yup.string().required(''),
  fourth: Yup.string().required(''),
  fifth: Yup.string().required(''),
  sixth: Yup.string().required(''),
})
